module.exports = __webpack_public_path__ + "static/media/bars.2bc48cc2.svg";